import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { clientCMS } from "../../sanity/clientCMS.js";
import imageUrlBuilder from "@sanity/image-url";
import LoadingContainer from "../LoadingContainer/index.js";
import ErrorContainer from "../ErrorContainer/index.js";
import NoDataContainer from "../NoDataContainer/index.js";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FiCalendar } from "react-icons/fi";
import { LuUserRoundPen } from "react-icons/lu";
import { TbNewsOff } from "react-icons/tb";
import "./AllPosts.css";

export default function AllPosts(props) {
  const [allPostsData, setAllPostsData] = useState(null);
  const [dataContainer, setDataContainer] = useState(null);
  const [dataCategories, setDataCategories] = useState(null);
  const [categorySelected, setCategorySelected] = useState("Todos");
  const builder = imageUrlBuilder(clientCMS);

  function urlFor(source) {
    return builder.image(source);
  }

  useEffect(() => {
    setDataContainer(LoadingContainer);
    clientCMS
      .fetch(
        `*[_type == "category"]{
        _id,
        title 
    }`,
      )
      .then((data) => {
        setDataCategories(data);
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
      });

    clientCMS
      .fetch(
        `*[_type == "post"] | order(_createdAt desc) {
        title,
        slug,
         body[]{
            ...,
            asset -> {
                     ...,
            "_key": _id
            }
        },
        mainImage{
            asset->{
            _id,
            url
            },
        },
        "name": author->name,
        publishedAt,
        overview,
        "categories": categories[]->title
    }`,
      )
      .then((data) => {
        setAllPostsData(data);
        if (data.length === 0)
          setDataContainer(
            <NoDataContainer
              icon={<TbNewsOff className="no-data-container-icon" />}
              message=" Sem destaques no momento"
            />,
          );
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!allPostsData) setDataContainer(ErrorContainer);
        else setDataContainer(LoadingContainer);
      });
  }, []);

  const filteredItens =
    categorySelected === "Todos"
      ? allPostsData
      : allPostsData.filter((item) =>
          item.categories.includes(categorySelected),
        );

  return (
    <Container>
      <Row>
        <Col className="noticias-categories">
          <button
            onClick={() => setCategorySelected("Todos")}
            style={{
              fontSize: props.subTextSize,
              backgroundColor:
                categorySelected === "Todos" ? props.btnColor : props.white, // Estilo dinâmico
              color:
                categorySelected === "Todos" ? props.white : props.btnColor,
              border:
                categorySelected === "Todos"
                  ? "none"
                  : `solid 1px ${props.btnColor}`,
            }}
            className="noticias-category-btn"
          >
            Todos
          </button>
          {dataCategories &&
            dataCategories.map((category) => (
              <button
                key={category.title}
                onClick={() => setCategorySelected(category.title)}
                style={{
                  fontSize: props.subTextSize,
                  backgroundColor:
                    categorySelected === category.title
                      ? props.btnColor
                      : props.white, // Estilo dinâmico
                  color:
                    categorySelected === category.title
                      ? props.white
                      : props.btnColor,
                  border:
                    categorySelected === category.title
                      ? "none"
                      : `solid 1px ${props.btnColor}`,
                }}
                className="noticias-category-btn"
              >
                {category.title}
              </button>
            ))}
        </Col>
      </Row>
      <Row>
        {filteredItens && filteredItens.length > 0 ? (
          filteredItens.map((post, index) => (
            <Col key={index} className="noticias-col">
              <div
                style={{ backgroundColor: props.white }}
                className="article-card"
              >
                <Link
                  to={"/destaques/" + post.slug.current}
                  key={post.slug.current}
                >
                  <img
                    src={urlFor(post.mainImage.asset.url)
                      .width(348)
                      .quality(100)
                      .dpr(2)
                      .url()}
                    alt="imagem artigo"
                    className="article-card-img"
                  />
                  <div className="article-card-title-content">
                    <div className="article-card-info">
                      <div
                        className="article-card-date"
                        style={{ color: props.textColor }}
                      >
                        <FiCalendar className="article-card-icon" />
                        {new Date(post.publishedAt).toLocaleDateString()}
                      </div>
                      <div
                        className="article-card-author"
                        style={{ color: props.textColor }}
                      >
                        <LuUserRoundPen className="article-card-icon" />
                        {post.name}
                      </div>
                    </div>
                    <h2
                      style={{
                        color: props.titleColor,
                        fontSize: props.subTitleSize,
                      }}
                    >
                      {post.title}
                    </h2>
                    <Container className="article-card-categories">
                      <Row>
                        {post.categories.map((category, id) => (
                          <Col
                            sm={4}
                            xs={4}
                            className="article-card-category-col"
                            key={id}
                            style={{ color: props.btnColor }}
                          >
                            <div className="article-card-category">
                              {category}
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                    <h4>{post.overview}</h4>
                    <div className="article-card-overlay" />
                  </div>
                </Link>
              </div>
            </Col>
          ))
        ) : filteredItens && filteredItens.length === 0 ? (
          <div className="no-data-container">
            <TbNewsOff className="no-data-container-icon" /> Sem destaques no
            momento
          </div>
        ) : (
          dataContainer
        )}
      </Row>
    </Container>
  );
}
